import {
    REQUEST_ASSIGN_STATES_MANAGER,
    RECEIVE_ASSIGN_STATES_MANAGER,
    ERROR_ASSIGN_STATES_MANAGER,

    REQUEST_ASSIGN_COUNTIES_MANAGER,
    RECEIVE_ASSIGN_COUNTIES_MANAGER,
    ERROR_ASSIGN_COUNTIES_MANAGER,
} from 'typeConstants';
import { appraiserManagerAssignRegion as initialState } from '../initialState.tsx';

const appraiserManagerAssignRegion = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_ASSIGN_STATES_MANAGER:
            return {
                ...state,
                isFetchingAssignedStates: true
            };
        case RECEIVE_ASSIGN_STATES_MANAGER:
            return {
                ...state,
                assignedStates: action.payload,
                isFetchingAssignedStates: false
            };
        case ERROR_ASSIGN_STATES_MANAGER:
            return {
                ...state,
                isFetchingAssignedStates: false
            };
        case REQUEST_ASSIGN_COUNTIES_MANAGER:
            return {
                ...state,
                isFetchingAssignedCounties: true
            };
        case RECEIVE_ASSIGN_COUNTIES_MANAGER:
            return {
                ...state,
                assignedCounties: action.payload,
                isFetchingAssignedCounties: false
            };
        case ERROR_ASSIGN_COUNTIES_MANAGER:
            return {
                ...state,
                isFetchingAssignedCounties: false
            };
        default:
            return state;
    }
};

export default appraiserManagerAssignRegion;